import React from 'react';
import { ProgressStep, WizardProgress } from './WizardProgress';
import { CreateSigningAppointmentFormData } from '../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { Show } from '../../../../shared/Show';
import { eSigningMethod } from '../../../../../types/signingAppointment/eSigningMethod';
import { DateAndAddressInfoSection } from './DateAndAddressInfoSection';

export const FormTemplate: React.FC<{
  progressStep: ProgressStep;
  wizardFormData: CreateSigningAppointmentFormData;
  children: React.ReactNode;
}> = ({ children, wizardFormData, progressStep }) => {
  return (
    <>
      <WizardProgress step={progressStep} wizardFormData={wizardFormData} />
      <Show when={progressStep !== ProgressStep.DETAILS && wizardFormData.signingMethod !== eSigningMethod.eSign}>
        <DateAndAddressInfoSection formData={wizardFormData} />
        <hr />
      </Show>

      {children}
    </>
  );
};
